export default __webpack_public_path__ + "static/media/ic_donut_large.c4d4ed24.svg";